import React, { useContext } from "react";
import { StateContext } from "../App";
import Error from "../components/Error";
import IssueList from "../components/IssueList";
import Loader from "../components/Loader";

const LandingPage = () => {
    const state = useContext(StateContext);
    const { failure } = state;
    const { loading } = state;

    const onClickBackToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    document.addEventListener("scroll", () => {
        const backToTop = document.querySelector("div.backToTop");
        if (window.scrollY >= 500) {
            backToTop.classList.add("visible");
        } else {
            backToTop.classList.remove("visible");
        }
    });
    if (!failure) {
        return (
            <>
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <IssueList />
                        <div
                            onClick={onClickBackToTop}
                            className="backToTop"></div>
                    </>
                )}
            </>
        );
    } else {
        return (
            <>
                <Error />
            </>
        );
    }
};

export default LandingPage;
